import * as React from "react";

import {
  Collapse,
  Nav,
  NavItem,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

import { Link } from "react-router-dom";

import { SignedInContext } from "../../SignedInContext";
import "./style.css";

export default class NavMenu extends React.Component<any, any> {
  pollysTimeout: any = null;
  toolsTimeout: any = null;
  contentTimeout: any = null;

  constructor(props: any) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      pollysDropdownOpen: false,
      toolsDropdownOpen: false,
      contentDropdownOpen: false,
    };
  }

  componentWillUnmount() {
    if (this.pollysTimeout) clearTimeout(this.pollysTimeout);
    if (this.toolsTimeout) clearTimeout(this.toolsTimeout);
    if (this.contentTimeout) clearTimeout(this.contentTimeout);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handlePollysMouseEnter = () => {
    if (this.pollysTimeout) clearTimeout(this.pollysTimeout);
    this.setState({ pollysDropdownOpen: true });
  };

  handlePollysMouseLeave = () => {
    this.pollysTimeout = setTimeout(() => {
      this.setState({ pollysDropdownOpen: false });
    }, 200);
  };

  handleToolsMouseEnter = () => {
    if (this.toolsTimeout) clearTimeout(this.toolsTimeout);
    this.setState({ toolsDropdownOpen: true });
  };

  handleToolsMouseLeave = () => {
    this.toolsTimeout = setTimeout(() => {
      this.setState({ toolsDropdownOpen: false });
    }, 200);
  };

  handleContentMouseEnter = () => {
    if (this.contentTimeout) clearTimeout(this.contentTimeout);
    this.setState({ contentDropdownOpen: true });
  };

  handleContentMouseLeave = () => {
    this.contentTimeout = setTimeout(() => {
      this.setState({ contentDropdownOpen: false });
    }, 200);
  };

  render() {
    return (
      <SignedInContext.Consumer>
        {({ signedIn, setSignedIn }) => (
          <Navbar dark color="dark" expand="md">
            {signedIn ? (
              <NavbarBrand tag={Link} to="/" style={{ cursor: "pointer" }}>
                <img
                  src="https://static.polly.ai/img/logo-color.svg"
                  width="35"
                  height="25"
                  alt=""
                />
                <span className="ml-2">Polly Admin</span>
              </NavbarBrand>
            ) : (
              <NavbarBrand href="/auth/google" style={{ cursor: "pointer" }}>
                <img
                  src="https://static.polly.ai/img/logo-color.svg"
                  width="35"
                  height="25"
                  alt=""
                />
                <span className="ml-2">Polly Admin</span>
              </NavbarBrand>
            )}
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                {signedIn ? (
                  <>
                    <NavItem className="nav-item-divider">
                      <Link className="nav-link" to="/users">
                        Users
                      </Link>
                    </NavItem>
                    <NavItem className="nav-item-divider">
                      <Link className="nav-link" to="/teams">
                        Teams
                      </Link>
                    </NavItem>
                    <NavItem className="nav-item-divider">
                      <Link className="nav-link" to="/platform-subscriptions">
                        Platform Subs
                      </Link>
                    </NavItem>
                    <NavItem className="nav-item-divider">
                      <Link className="nav-link" to="/organizations">
                        Orgs
                      </Link>
                    </NavItem>
                    <NavItem className="nav-item-divider">
                      <Link className="nav-link" to="/enterprise">
                        Grids
                      </Link>
                    </NavItem>
                    <Dropdown
                      nav
                      inNavbar
                      isOpen={this.state.pollysDropdownOpen}
                      toggle={() => {}}
                      onMouseEnter={this.handlePollysMouseEnter}
                      onMouseLeave={this.handlePollysMouseLeave}
                      className="nav-item-divider"
                    >
                      <DropdownToggle nav caret>
                        Pollys
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem tag={Link} to="/polls">
                          Polls
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/surveys">
                          Surveys
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/trivias">
                          Trivias
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/qandas">
                          Q&As
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/tracks">
                          Tracks
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/workflows">
                          Workflows
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <Dropdown
                      nav
                      inNavbar
                      isOpen={this.state.contentDropdownOpen}
                      toggle={() => {}}
                      onMouseEnter={this.handleContentMouseEnter}
                      onMouseLeave={this.handleContentMouseLeave}
                      className="nav-item-divider"
                    >
                      <DropdownToggle nav caret>
                        Content
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem tag={Link} to="/content/questions">
                          Questions
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/content/quality">
                          Quality
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/content/flagged">
                          Flagged
                        </DropdownItem>
                        {/* The generation pipeline. Separated because these are
                            a workflow — draft, review, publish — rather than
                            views of the live library above. */}
                        <DropdownItem divider />
                        <DropdownItem header>Pipeline</DropdownItem>
                        <DropdownItem tag={Link} to="/content/generate">
                          Generate
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/content/review">
                          Review queue
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/content/drafts">
                          Drafts
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <Dropdown
                      nav
                      inNavbar
                      isOpen={this.state.toolsDropdownOpen}
                      toggle={() => {}}
                      onMouseEnter={this.handleToolsMouseEnter}
                      onMouseLeave={this.handleToolsMouseLeave}
                      className="nav-item-divider"
                    >
                      <DropdownToggle nav caret>
                        Tools
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem tag={Link} to="/meteor-resume-tokens">
                          Meteor Tokens
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/campaigns">
                          Campaign Manager
                        </DropdownItem>
                        <DropdownItem
                          tag="a"
                          href="https://web.polly.ai/admin-theme-preview"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Slide Generator
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <NavItem>
                      <a
                        className="nav-link"
                        href="/auth/logout"
                        onClick={() => {
                          setSignedIn(false);
                        }}
                      >
                        Sign Out
                      </a>
                    </NavItem>
                  </>
                ) : (
                  <>
                    <NavItem>
                      <a href="/auth/google" className="nav-link">
                        Sign In
                      </a>
                    </NavItem>
                  </>
                )}
              </Nav>
            </Collapse>
          </Navbar>
        )}
      </SignedInContext.Consumer>
    );
  }
}
